import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import axios from "axios";
export default {
  data() {
    return {
      previewUrl: null,
      // 图片预览 URL
      selectedFile: null,
      // 选中的文件对象
      imageUrl: null // 后端返回的图片访问 URL
    };
  },
  async mounted() {
    // 隐藏菜单栏和其他元素（原有逻辑保留）
    document.getElementById("menu").style.display = "none";
    document.getElementById("showAfterLogin").style.display = "none";
  },
  methods: {
    // 点击按钮触发文件选择
    selectImage() {
      this.$refs.fileInput.click();
    },
    // 处理选择文件后
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedFile = file;
        // 创建本地预览 URL
        this.previewUrl = URL.createObjectURL(file);
        // 上传文件到后端
        this.uploadImage(file);
      }
    },
    // 上传文件到后端
    async uploadImage(file) {
      const formData = new FormData();
      formData.append("image", file); // 添加文件到表单数据

      try {
        // 使用 axios 发送 POST 请求
        const response = await axios.post("https://backend.wonology.com/exam/uploadImage", formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });

        // 可以在这里处理后端返回的数据
        if (response.data.code === "0000") {
          // alert(`文件上传成功，存储名称为: ${response.data.data}`);
          alert("上传成功");
          this.imageUrl = "http://43.134.198.187/examImage/" + response.data.data;
        } else {
          alert(`上传失败: ${response.data.msg}`);
        }
      } catch (error) {
        // 捕获并打印错误信息
        console.error("上传失败:", error.response?.data || error.message);
        alert("上传失败，请稍后再试");
      }
    }
  }
};